<template>
  <div class="wrap">
    <div id="ccod_banner" v-if="!showST">
      <div class="imgPic">
        <el-carousel
          arrow="never"
          :interval="3000"
          height="560px"
          style="overflow-x: hidden"
        >
          <el-carousel-item>
            <img
              style="width: 100%; height: 100%"
              src="../assets/img/b01.png"
              alt=""
            />
            <div class="el-carousel-banner">
              <img src="../assets/img/lo_.png" />
            </div>
            <div class="textBox textBox1">
              <div class="rightT">
                <p style="font-size: 24px;">致力于提高中国企业的服务效率和质量</p>
                <!-- <p>拥有15年企业云服务运营经验</p> -->
              </div>
            </div>
            <!-- <div class="detailBox">
              <router-link to="/AboutUs"
                ><div class="goDetail">了解详情</div></router-link
              >
            </div> -->
          </el-carousel-item>
          <!-- <el-carousel-item>
            <img
              style="width: 100%; height: 100%"
              src="../assets/img/b02.png"
              alt=""
            />
            <div class="el-carousel-banner">
              <img src="../assets/img/lo_.png" />
            </div>
            <div class="textBox textBox2">
              <div style="font-weight: bold; font-size: 18px">
                服务1000多家大中型企业和数百万家中小企业
              </div>
            </div>
            <div class="detailBox">
              <router-link to="/AboutUs"
                ><div class="goDetail">了解详情</div></router-link
              >
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img
              style="width: 100%; height: 100%"
              src="../assets/img/b03.png"
              alt=""
            />
            <div class="el-carousel-banner">
              <img src="../assets/img/lo_.png" />
            </div>
            <div class="textBox">
              <div class="rightT">
                <p>每年帮助客户创造数千亿元销售收入</p>
                <p>每年通过平台触达服务五亿C端用户人群</p>
              </div>
            </div>
            <div class="detailBox">
              <router-link to="/AboutUs"
                ><div class="goDetail">了解详情</div></router-link
              >
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <img
              style="width: 100%; height: 100%"
              src="../assets/img/b04.jpg"
              alt="" 
            />
            <div class="el-carousel-banner">
              <img src="../assets/img/lo_.png" />
            </div>
            <div class="detailBox">
              <div class="goDetail" @click="showStatement()">了解详情</div>
            </div>
          </el-carousel-item> -->
        </el-carousel>
      </div>
    </div>
    <h3 class="ccod_title f30 f_bold" style="margin-top: 80px" v-if="!showST">
      青牛云服务总览
    </h3>
    <p class="ccod_titles" v-if="!showST"><span class="line"></span></p>
    <div class="banIndex" v-if="!showST">
      <div class="ccod_ba">
        <div class="ba_img_1"></div>
      </div>

      <div class="ccod_qing">
        <div class="ccod_qingniu">
          <img src="../assets/img/img_1.png" />
          <h3>全媒体联络平台</h3>
        </div>
        <div class="ccod_qingniu">
          <img src="../assets/img/img_2.png" />
          <h3>数字指挥舱</h3>
        </div>
        <div class="ccod_qingniu">
          <img src="../assets/img/video_platform.png" />
          <h3>视频平台</h3>
        </div>
        <div class="ccod_qingniu">
          <img src="../assets/img/img_3.png" />
          <h3>云网助手</h3>
        </div>
      </div>

      <div class="ccod_ba" v-if="!showST">
        <div class="ba_img_2"></div>
      </div>
    </div>

    <div class="ccod_detail" v-if="!showST">
      <div class="ccod_detail_1" style="background: #f8f8f8">
        <div class="ccod_detail_list" style="margin-right: 80px">
          <h3 class="f30">全媒体联络平台</h3>
          <!-- <p class="mid">中国企业联络云服务的开创者与引领者</p> -->
          <p style="text-indent: 36px">
            企业客户使用公司全媒体联络平台产品，可以通过电话、短信、APP、即时消息、视频、5G消息等多种联络方式，覆盖客户前、中、后台多项业务场景，帮助企业客户快速建立与其终端用户之间全方位、多触点的沟通联络。
          </p>
          <router-link to="/QingYun"><button>了解详情</button></router-link>
        </div>
        <img src="../assets/img/img_4.png" />
      </div>

      <div class="ccod_detail_1">
        <img src="../assets/img/img_5.png" />
        <div class="ccod_detail_list" style="margin-left: 80px">
          <h3 class="f30">数字指挥舱</h3>
          <!-- <p class="mid">为客户更精准投递服务</p> -->
          <p style="text-indent: 36px">
            以数字金融的KPI为核心，将多年实践积累的总行级业务咨询服务、数仓服务、报表服务和建模服务融为一体，提供了一站式的决策指挥舱快速定制服务，并根据各代表银行的技术规范制定了产品部署积木化方案。
          </p>
          <router-link to="/DigitalCommand"><button>了解详情</button></router-link>
        </div>
      </div>

      <div class="ccod_detail_1" style="background: #f8f8f8">
        <div class="ccod_detail_list" style="margin-right: 80px">
          <h3 class="f30">视频平台</h3>
          <!-- <p class="mid">融合AI服务 让企业服务轻松自如</p> -->
          <p style="text-indent: 36px">
            面向运营商通信网络能力 (5G VoLTE/VONR) 构建，为企业客户和其终端用户间的联络提供视频能力保障。企业客户可以基于视频平台开展视频通话、面签、双录等场景应用，新增了服务渠道，能够为企业客户和用户节省时间，提升了用户体验及服务效率。
          </p>
          <router-link to="/VideoPlatform"><button>了解详情</button></router-link>
        </div>
        <img src="../assets/img/img_6.png" />
      </div>

      <!-- <div class="ccod_detail_1" style="background: #f8f8f8">
        <img src="../assets/img/img_6.png" />
        <div class="ccod_detail_list" style="margin-right: 80px">
          <h3 class="f30">云网助手</h3>
          <p style="text-indent: 36px">
            云网助手依托中国电信的云网服务生态结合互联网及5G技术，为小微企业提供简单高效、实用的全流程服务场景解决方案，能够通过数字化应用提升用户全方位的销售、运营、服务的能力
          </p>
          <router-link to="/QingniuAI"><button>了解详情</button></router-link>
        </div>
      </div> -->
      <div class="ccod_detail_1">
          <img src="../assets/img/cloud_assistant.png" width="390px"  height="282px"/>
        <div class="ccod_detail_list" style="margin-left: 80px">
          <h3 class="f30">云网助手</h3>
          <!-- <p class="mid">融合AI服务 让企业服务轻松自如</p> -->
          <p style="text-indent: 36px">
            云网助手依托中国电信的云网服务生态结合互联网及5G技术，为小微企业提供简单高效、实用的全流程服务场景解决方案，能够通过数字化应用提升用户全方位的运营服务的能力。
          </p>
          <router-link to="/CloudAssi"><button>了解详情</button></router-link>
        </div>
      </div>

     
    </div>
    <!-- <h3 class="ccod_title f30" style="margin-top: 80px; font-weight: bold" v-if="!showST">
      合作伙伴
    </h3>
    <p class="ccod_titles" v-if="!showST"><span class="line"></span></p>
    <div style="background: #fff; padding-top: 32px" v-if="!showST"></div>
    <div class="ccod_partner" v-if="!showST">
      <img src="../assets/img/partner.png" alt="" />
    </div>
    <div style="background: #fff; padding-bottom: 70px"></div>
      <img v-if="showST" src="../assets/img/statement.jpg" style="width: 100%;position:absolute;top:60px;left:0px;z-index:99;background-color:#fff;" />
      <i class="el-icon-close" @click="hideStatement()" v-if="showST" style="font-size:60px;position:fixed;top:100px;right:40px;z-index:99;"></i> -->
  </div>
</template>

<script>
import MtaH5 from "mta-h5-analysis";
export default {
  data() {
    return {
      isShow: false,
      showST: false,
    };
  },
  mounted() {
    MtaH5.init({
      sid: "500715901", //必填，统计用的appid
      //"cid":'********', //如果开启自定义事件，此项目为必填，否则不填
      autoReport: 0, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
      senseHash: 0, //hash锚点是否进入url统计
      senseQuery: 0, //url参数是否进入url统计
      performanceMonitor: 0, //是否开启性能监控
      ignoreParams: [], //开启url参数上报时，可忽略部分参数拼接上报
    });
    MtaH5.pgv();
  },
  methods: {
    hoverMenuItem() {
      this.isShow = !this.isShow;
    },
    showStatement() {
      this.showST = true;
    },    
    hideStatement() {
      this.showST = false;
      // window.location.href = "#ccod_banner" 
    },
  },
};
</script>

<style >
.el-carousel-banner {
  width: 100%;
  display: flex;
  display: -ms-flexbox;
  justify-content: center;
  -ms-justify-content: center;
  position: absolute;
  top: 160px;
}
.ccod_title {
  text-align: center;
  margin: 0;
  padding: 0;
}
.ccod_titles {
  text-align: center;
  margin: 0;
  padding: 0;
}
.line {
  width: 62px;
  height: 3px;
  display: inline-block;
  margin-top: 20px;
  background: #ff882f;
}
.ccod_qing {
  width: 900px;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.ccod_qingniu {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 155px;
}
.ccod_qingniu img {
  width: 87px;
  height: 101px;
}
.ccod_qingniu h3 {
  margin: 37px 0 24px;
}
.ccod_partner {
  width: 100%;
  /* height: 700px; */
  /* background: url('../assets/img/partner.png') no-repeat center;
    background-size: 100% 100%;*/
  background: #fff;
  cursor: pointer;
}
.ccod_detail {
  width: 100%;

  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.detailBox {
  position: absolute;
  left: 0;
  bottom: 100px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.goDetail {
  display: inline-block;
  width: 130px;
  height: 35px;
  background: rgba(255, 255, 255, 0.8);
  color: #000;
  line-height: 35px;
  margin-top: 24px;
  cursor: pointer;
  transition: 0.5s ease all;
  -moz-transition: 0.5s ease all; /* Firefox 4 */
  -webkit-transition: 0.5s ease all; /* Safari and Chrome */
  -o-transition: 0.5s ease all; /* Opera */
}

.goDetail:hover {
  background: #fff;
  box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.8);
}
.ccod_detail_1 {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ccod_detail_1 a {
  color: inherit;
}
.ccod_detail_list p {
  font-size: 18px;
  line-height: 28px;
  color: #333;
  text-align: justify;
}
.ccod_detail_list .mid {
  margin-bottom: 46px;
  text-align: center;
  font-weight: bold;
}
.ccod_detail_list h3 {
  margin-bottom: 16px;
  font-weight: bold;
}
.ccod_detail_list {
  max-width: 460px;
}
.ccod_detail_list button {
  border: 0;
  width: 130px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #555;
  color: #fff;
  font-size: 14px;
  margin-top: 55px;
  outline: none;
}
.ccod_detail_list button:hover {
  background: #fff;
  color: #000;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
}
#ccod_banner {
  position: relative;
  width: 100%;
  height: 560px;
}
#ccod_banner .imgPic {
  width: 100%;
  height: 560px;
}
.el-carousel--horizontal {
  height: 560px;
}
.el-carousel__container {
  width: 100%;
  height: 560px;
  position: absolute !important;
}
#ccod_banner .el-carousel .el-carousel-item img {
  width: 100%;
  height: 100%;
}
.el-carousel__indicators--horizontal {
  bottom: 50px !important;
}

.el-carousel__indicator.is-active button {
  background: #ffba00 !important;
}
.el-carousel__item {
  position: absolute;
}
.el-carousel__item .textBox {
  position: absolute;
  left: 0;
  top: 310px;
  width: 100%;
  display: flex;
  justify-content: center;
  color: #fff;
  line-height: 30px;
  align-items: center;
}
.textBox1 {
  /*bottom: 180px;*/
}
.textBox2 {
  flex-direction: column;
  /*bottom: 160px!important;*/
}
.textBox3 {
  flex-direction: column;
  /*bottom: 160px!important;*/
}
.textBox .leftT {
  font-size: 60px;
  font-weight: bold;
  margin-right: 11px;
}
.textBox .rightT {
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: bold;
  /* text-align: left; */
}
.ccod_ba {
  width: 100%;
  display: flex;
  justify-content: center;
  /*display: none;*/
}
.ccod_ba .ba_img_1 {
  width: 862px;
  height: 0px;
  margin-top: 40px;
  margin-bottom: 30px;
  background: url("../assets/img/smart.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.ccod_ba .ba_img_2 {
  width: 1200px;
  height: 0px;
  margin-top: 30px;
  background: url("../assets/img/tel_.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.ccod_ba ul {
  width: 40%;
  padding: 0 30%;
  display: flex;
  justify-content: space-around;
}
.ccod_ba ul li {
  border: 1px dashed #ccc;
  padding: 5px 15px;
}
.ccod_ba .ba_img_1,
.ccod_ba .ba_img_2 {
  transition: all 0.3s;
  -moz-transition: all 0.3s; /* Firefox 4 */
  -webkit-transition: all 0.3s; /* Safari 和 Chrome */
  -o-transition: all 0.3s;
}
.banIndex {
  padding-bottom: 50px;
}
.banIndex:hover .ccod_ba .ba_img_1 {
  height: 178px;
  transition: all 0.3s;
  -moz-transition: all 0.06s; /* Firefox 4 */
  -webkit-transition: all 0.3s; /* Safari 和 Chrome */
  -o-transition: all 0.3s;
}
.banIndex:hover .ccod_ba .ba_img_2 {
  height: 240px;
  transition: all 0.3s;
  -moz-transition: all 0.3s; /* Firefox 4 */
  -webkit-transition: all 0.3s; /* Safari 和 Chrome */
  -o-transition: all 0.3s;
}
.el-carousel__indicator.is-active button {
    background: #00000000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/Index.vue